import React, { Component } from "react";
import FilterSubSection from "~/scripts/components/products/FilterSubSection";
import Range from "~/scripts/components/products/Range";

class LumenOutput extends Component {
    render() {
        return (
            <FilterSubSection heading="Lumen Output">
                <Range attribute="lumens" sliderMin={0} sliderMax={25000} />
            </FilterSubSection>
        );
    }
}

export default LumenOutput;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/LumenOutput.js